// src/lib/contrat-caution-apercu.js — CONTRAT V2 (revue M1) : verdict caution du
// contrat pour les APERÇUS ADMIN (ContratTab logements + ResaV2Modal).
//
// Nom distinct depuis F10 phase 2 (03/10, ex-src/lib/contrat-caution.js) : ce
// n'est PAS une copie de lib/contrat-caution.js. Le serveur lit la matrice en
// base ; l'écran DEMANDE au serveur son verdict (/api/beds24-mapping). Deux
// fonctions différentes, aucun code recopié.
//
// MIROIR DÉCISIONNEL de lib/contrat-caution.js (serveur — il fait FOI, ne
// modifier l'un sans l'autre) : même dérivation UNIQUE isCautionDueForStay
// = (montant caution du logement > 0) ET (cellule matrice caution ON pour
// (logement × direct)). Le contrat est un document Direct : plateforme
// TOUJOURS 'direct', quelle que soit la source de la résa sélectionnée.
//
// La table `journey_composition_config` est RLS server-only → le terme
// matrice est lu via l'action admin `journey_composition_get`
// (/api/beds24-mapping, requireAdmin) qui renvoie la résolution EFFECTIVE
// serveur (cascade logement > global > CODED_DEFAULTS). Le terme montant est
// le miroir client existant hasCautionAmount (src/lib/caution-helpers.js).
//
// Sémantique de retour (doctrine cautionDue de genContratHTML) :
//   - true / false → verdict de la dérivation (false = variante « aucun
//     dépôt demandé » — verdict explicite, pas un accident) ;
//   - undefined → résolution impossible (pas de session, API KO, réponse
//     inattendue) → rendu HISTORIQUE (mention caution conservée) — fail-safe
//     « jamais false par accident ».

import { supabase } from '../supabase'
import { hasCautionAmount } from './caution-helpers'

/**
 * Résout `cautionDue` pour un aperçu admin de contrat.
 * @param {object|null} log — log du cfg (id + montants ; peut porter parentLog).
 * @returns {Promise<boolean|undefined>} cf. cartouche.
 */
export async function resolveContratCautionDueClient(log) {
  try {
    if (!log || !log.id) return undefined
    // Terme MONTANT (miroir resolveCautionFromLog) : sans montant, la
    // dérivation dit false quel que soit l'état matrice — aucun appel réseau.
    if (!hasCautionAmount(log)) return false
    const { data: { session } } = await supabase.auth.getSession()
    const token = session?.access_token
    if (!token) return undefined
    const r = await fetch('/api/beds24-mapping', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ action: 'journey_composition_get', logement_id: log.id }),
    })
    if (!r.ok) return undefined
    const json = await r.json().catch(() => null)
    const cautionOn = json?.logement?.effective?.direct?.blocs?.caution
    if (typeof cautionOn !== 'boolean') return undefined
    return cautionOn
  } catch (e) {
    console.error('[contrat] verdict caution (aperçu admin) irrésoluble — rendu historique', e)
    return undefined
  }
}
